import { mailFilter } from '../strings.locstring.json';
import loc from 'owa-localize';
import getViewFilterDisplay from '../helpers/getViewFilterDisplay';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react';
import { lazySelectFilter } from 'owa-mail-filter-actions';
import { ActionSource } from 'owa-mail-store';
import { resetFocus } from 'owa-mail-focus-manager';
import KeyboardCharCodes from 'owa-hotkeys/lib/utils/keyboardCharCodes';
import { MailFilterContextMenu } from 'owa-mail-list-filter-view';
import { getViewFilterForTable, listViewStore } from 'owa-mail-list-store';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import * as React from 'react';
import {
    filterViewStore,
    hideFilterDropDownContextMenu,
    showFilterDropDownContextMenu,
} from 'owa-mail-list-filter-store';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { ControlIcons } from 'owa-control-icons';

const classNames = require('classnames');
const styles = require('./MailListFilter.scss');

export interface MailListFilterProps {
    supportedViewFilters: ViewFilter[];
    filterMenuSource: ActionSource;
    tableViewId: string;
    containerClassName?: string;
    isInboxWithPivots?: boolean;
}

@observer
export default class MailListFilter extends React.Component<MailListFilterProps, {}> {
    private container: HTMLElement;

    private onFilterClick = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        this.onSelectFilter();
    };

    private onSelectFilter() {
        if (getViewFilterForTable(listViewStore.tableViews.get(this.props.tableViewId)) === 'All') {
            showFilterDropDownContextMenu();
        } else {
            // Dismiss the filter if the LV is already filtered
            lazySelectFilter.importAndExecute('All', this.props.filterMenuSource);

            // Reset focus when the filter is closing and changing to "All"
            resetFocus();
        }
    }

    /**
     * Called when user presses keyboard on the filter dropdown title in listview
     */
    private onKeyDownOnFilter = (ev: React.KeyboardEvent<HTMLElement>) => {
        switch (ev.keyCode) {
            case KeyboardCharCodes.Enter:
            case KeyboardCharCodes.Space:
                ev.stopPropagation();
                ev.preventDefault();
                this.onSelectFilter();
                break;
        }
    };

    private dismissContextMenu(): void {
        hideFilterDropDownContextMenu();

        // Reset focus when filter context menu is dismissed
        resetFocus();
    }

    render() {
        const currentSelectedFilter = getViewFilterForTable(
            listViewStore.tableViews.get(this.props.tableViewId)
        );
        const isAllFilterSelected = currentSelectedFilter == 'All';
        const containerClassNames = classNames(
            this.props.containerClassName,
            this.props.isInboxWithPivots ? styles.filterPivots : styles.filter
        );
        const ariaProps: AriaProperties = {
            role: AriaRoles.button,
        };

        return (
            <div
                ref={ref => (this.container = ref)}
                className={containerClassNames}
                onClick={this.onFilterClick}
                onKeyDown={this.onKeyDownOnFilter}
                {...generateDomPropertiesForAria(ariaProps)}
                tabIndex={0}>
                {isAllFilterSelected
                    ? loc(mailFilter)
                    : getViewFilterDisplay(currentSelectedFilter)}
                <Icon
                    className={styles.icon}
                    iconName={
                        isAllFilterSelected ? ControlIcons.ChevronDownMed : ControlIcons.Cancel
                    }
                />
                {filterViewStore.filterContextMenuDisplayState && (
                    <MailFilterContextMenu
                        currentViewFilter={currentSelectedFilter}
                        supportedViewFilters={this.props.supportedViewFilters}
                        dismissContextMenu={this.dismissContextMenu}
                        contextMenuTargetElement={this.container}
                        filterMenuSource={this.props.filterMenuSource}
                        tableViewId={this.props.tableViewId}
                    />
                )}
            </div>
        );
    }
}
